import { render, staticRenderFns } from "./ProjectsItem.vue?vue&type=template&id=6d41b35a"
import script from "./ProjectsItem.vue?vue&type=script&lang=ts"
export * from "./ProjectsItem.vue?vue&type=script&lang=ts"
import style0 from "./ProjectsItem.vue?vue&type=style&index=0&id=6d41b35a&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports